import React, {useState} from 'react';
import SelectInput from '../../../../Common/components/select-input';
import TextInput from "../../../../Common/components/text-input";;

function Tab1({tab, onValidate}) {
    const [submitAttempted, setSubmitAttempted] = useState(false)

    const handleSubmit = _ => {
        onValidate();
        setSubmitAttempted(true)
    }

    return (
        <div className="form mt-0 mt-lg-10">
            <div
                className="pb-5"
                data-wizard-type="step-content"
                data-wizard-state={tab === 1 ? "current" : ""}
            >
                <div className="mb-10 h3 font-weight-bold text-dark">Plan Details</div>
                <div className="row">
                    <TextInput
                        label="Plan name*"
                        name="planName"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                    <SelectInput
                        label="Currency*"
                        name="currency"
                        type="text"
                        shouldShowError={submitAttempted}
                        options={[
                            "USD",
                            "NGN"
                        ]}
                    />
                     <TextInput
                        label="Tenure*"
                        name="tenor"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                </div>
                <div className="row">
                    <TextInput
                        label="Plan Description*"
                        name="planDescription"
                        type="text"
                        shouldShowError={submitAttempted}
                    />
                </div>
                
                <div className="row">
                    <TextInput
                        label="Interest Rate"
                        name="interestRate"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="Maximum Amount"
                        name="maximumAmount"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="Minimum Amount"
                        name="minimumAmount"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                    <TextInput
                        label="T Plus Days"
                        name="tPlusDays"
                        type="number"
                        shouldShowError={submitAttempted}
                    />
                </div>

                {/* <!--begin: Wizard Actions--> */}
                <div className="text-right border-top mt-5 pt-10">
                    <button
                        onClick={handleSubmit}
                        type="button"
                        className="btn btn-primary font-weight-bolder text-uppercase px-9 py-4"
                    >
                        Next
                    </button>
                </div>
                {/* <!--end: Wizard Actions--> */}
            </div>
        </div>
    );
}

export default Tab1;